/** Clears the entire localStorage for this origin (survey draft keys). */
export function clearAllLocalStorage(): void {
  try {
    localStorage.clear();
  } catch {
    /* private mode / quota */
  }
}
